<template>
  <!-- <vs-card-group class="remove-scroll" w="12"></vs-card-group> -->
  <div class="episodes-vertical">
    <vs-card class="episode-card-vertical" type="3" v-for="episode in episodes" :key="episode.id" @click="!(episode.tvUrl && episode.seasonNumber) ? goToLink(`https://videnti.co/watch/${seriesUrl}/${seasonNumber}/${episode.episode_number}`) : goToLink(`https://videnti.co/watch/${episode.show_url}/${episode.season_number}/${episode.episode_number}`)">

      <template #title>
        <div class="title-container">
          <div class="episode-number">
            <small v-if="episode.episode_number_custom">{{ episode.episode_number_custom }}</small>
            <small v-else-if="showSeasonNumber">T{{seasonNumber ? seasonNumber : episode.season_number}}E{{episode.episode_number}}</small>
            <small v-else>Episodio {{episode.episode_number}}</small>
          </div>
          <h3 class="episode-name-cut animate" ref="animatedTexts" @mouseover="checkElementAnimation">{{episode.name}}</h3>
        </div>
      </template>

      <template #img>
        <div class="ratio ratio-16x9"> <!-- invert-small -->
          <img v-if="episode.thumbnail != null || episode.thumbnail === ''"
               :src="episode.thumbnail"
               alt="" @error="imageUrlAlt" width="1080px">
          <img v-else-if="episode.count_links === 0"
               src="https://storage.googleapis.com/balde-1/various/placeholders/unavailable_x.png"
               alt="" @error="imageUrlAlt" width="1080px" loading="lazy">
          <img v-else
               src="https://storage.googleapis.com/balde-1/various/placeholders/noimg_x.png"
               alt="" @error="imageUrlAlt" width="1080px" loading="lazy">
        </div>
        <progress v-if="episode.seenStatus === 2"
                  :aria-valuemax="episode.seconds + episode.minutes*60 + episode.hours*60*60"
                  :max="episode.seconds + episode.minutes*60 + episode.hours*60*60"
                  :aria-valuenow="(episode.durationStatus === undefined) ? 0 : getSecondsFromISO(episode.durationStatus)"
                  :value="(episode.durationStatus === undefined) ? 0 : getSecondsFromISO(episode.durationStatus)"
        ></progress>
        <progress v-if="episode.seenStatus === 1"
                  :aria-valuemax="episode.seconds + episode.minutes*60 + episode.hours*60*60"
                  :max="episode.seconds + episode.minutes*60 + episode.hours*60*60"
                  :aria-valuenow="episode.seconds + episode.minutes*60 + episode.hours*60*60 + 1"
                  :value="episode.seconds + episode.minutes*60 + episode.hours*60*60 + 1"
        ></progress>
      </template>
      <template #text>
        <p class="episode-detail">
          {{ episode.hours ? episode.hours + ":" : "" }}{{ (episode.minutes && episode.minutes !== 0) && (episode.seconds && episode.seconds !== 0 ) ? episode.minutes.zeroPad() + ":" + episode.seconds.zeroPad() + " ·" : "" }} {{ getVideoType(episode.type, (355>windowWidth)) }} {{ episode.released ? ("· " /* "Estrenado el" */ + $luxonDateTime.fromISO(episode.released).toLocaleString($luxonDateTime.DATE_SHORT)) : "" }}
        </p>
        <p class="episode-description">
          {{ episode.description }}
        </p>
      </template>
      <template #interactions>
        <vs-button v-if="seriesName || episode.tvName" class="btn-chat" shadow style="background: #195bff !important;" @click.stop="openShowInfo ? openShowInfo(null, episode.show_name, episode.show_url) : goToLink(`https://videnti.co/watch/${seriesUrl}`)">
          <span class="span"> {{seriesName ? seriesName : episode.show_name}} </span>
        </vs-button>
        <!-- <vs-button class="btn-chat btn-ep-num" shadow style="">
          <span v-if="episodio.customNumberName">{{ episodio.customNumberName }}</span>
          <span v-else-if="showSeasonNumber">T{{seasonNumber ? seasonNumber : episode.seasonNumber}}E{{episodio.number}}</span>
          <span class="span" v-else>Episodio {{episodio.number}}</span>
        </vs-button> -->
      </template>
    </vs-card>
  </div>
</template>

<script>

import {getVideoType} from "../utils/helpers";

export default {
  name: "EpisodesCardsSingleSeason",
  props: ['episodes', 'seriesUrl', 'seriesName', 'seasonNumber', 'showSeasonNumber', 'openShowInfo'],
  methods: {
    getVideoType,
    imageUrlAlt(event) {
      event.target.src = "https://i.imgur.com/Zx6wTMp.png"
    },
    getSecondsFromISO(input) {
      if (input === null) return 0;
      return this.$temporal.Duration.from(input).total({ unit: 'second' });
    },
    goToEpisode(temporada, episodio) {
      if (window.location.pathname.endsWith("/")) {
        window.location = window.location.origin + window.location.pathname + temporada + "/" + episodio;
      } else {
        window.location = window.location.origin + window.location.pathname + "/" + temporada + "/" + episodio;
      }
    },
    goToLink(link, blank) {
      if (blank) {
        window.open(link);
      } else {
        window.location = link;
      }
    },
    checkElementAnimation: function (e) {
      const element = e.target;
      if (element.clientWidth <= element.parentElement.clientWidth) {
        element.classList.remove("animate");
      }
      /* console.log("Element CLIENTWIDTH: " + element.clientWidth);
      console.log("Parent CLIENTWIDTH: " + element.parentElement.clientWidth); */
    },
    recalibrateData() {
      this.windowWidth = window.innerWidth
      // this.calculateAnimationDurations();
    },
    calculateAnimationDurations() {
      const animatedTextElements = this.$refs.animatedTexts;

      animatedTextElements.forEach((element) => {
        console.dir(element)
        // const index = element.dataset.index;
        const textWidth = element.scrollWidth;
        const containerWidth = element.parentElement.offsetWidth;

        // Calcula la duración proporcional al desplazamiento requerido para el texto
        // Puedes ajustar el valor multiplicador (500 en este caso) para controlar la velocidad
        const animationDuration = (textWidth / containerWidth) * 1000;
        element.style.animationDuration = `${animationDuration}ms`;
      });
    },
  },
  data() {
    return {
      windowWidth: 0
    }
  },
  // 355
  created() {
    this.windowWidth = window.innerWidth
    window.addEventListener("resize", this.recalibrateData);
  },
  mounted() {
    console.log(this.$refs.animatedTexts);
    this.calculateAnimationDurations();
    window.addEventListener("resize", this.calculateAnimationDurations);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateAnimationDurations);
  },
  destroyed() {
    window.removeEventListener("resize", this.recalibrateData);
  },
}
</script>

<style scoped>
.title-container .episode-name-cut {
  display: block;
}

.title-container .animate:hover {
  display: inline-block;
  overflow: visible;
  text-overflow: clip;
  position: relative;
  /*animation: LeftRight 5s infinite alternate ease-in-out;*/
  animation: LeftRight 5s 1 forwards ease-in-out;
}

</style>

<style>
.vs-card-content.type-3.episode-card-vertical .vs-card {
  max-width: unset;
  margin: 0.5rem 0;
}

.vs-card-content.type-3.episode-card-vertical .vs-card:hover {
  -webkit-transform: scale(1.01);
  transform: scale(1.01);
}

.vs-card-content.type-3.episode-card-vertical .vs-card .vs-card__img {
  /* width: 30% !important; */
  width: 40% !important;
}

.vs-card-content.type-3.episode-card-vertical .vs-card .vs-card__img img {
  min-width: unset;
}

.vs-card-content.type-3.episode-card-vertical .vs-card .vs-card__text {
  /* width: 70% !important; */
  width: 60% !important;
}
</style>

<style scoped lang="scss">
@import "~@elbuenanvita/vuesax/src/styles/mixins";

.title-container {
  white-space: nowrap;
  position: relative;
  border-radius: 5px;
  width: 100%;
  overflow: {
    x: visible;
    y: visible;
  }

  &:hover { overflow-x: hidden; }

  @include media-breakpoint-down("sm") {
    white-space: normal;
    line-height: 1.2rem;
    overflow: {
      x: visible;
    }

    .episode-number { margin-bottom: .25rem }
    // .episode-name-cut { height: calc(1.1rem + 1px); }
  }

  .episode-number {
    text-transform: uppercase;
    // font-size: .625rem;
    font-size: 0.675rem;
  }

  .episode-name-cut {
    font-weight: 600;
    // height: calc(1.1rem + 1px);
  }

  .animate {
    overflow: {
      x: hidden;
      y: visible;
    }
    text-overflow: ellipsis;

    @include media-breakpoint-down("sm") {
      overflow: {
        x: hidden;
        y: hidden;
      }
    }
  }
}

.episode-description {
  margin-top: .2rem;
  color: #8b8b8b;

  @include media-breakpoint-down("sm") {
    display: none;
  }
}

.episode-detail {
  @include media-breakpoint-down("sm") {
    margin-top: 0.4rem;
    font-size: .750rem;
  }
}

progress {
  appearance: none;
  position: absolute;
  width: 100%;
  height: 0.5rem;
  bottom: 0;
  left: 0;
  overflow: hidden;
  color: rgb(var(--vs-primary));
}

progress::-webkit-progress-value { background-color: rgb(var(--vs-primary)); }
</style>

<style lang="scss">
.vs-card-content.type-3.episode-card-vertical {
  .vs-card {
    .vs-card__text {
      .vs-card__title {
        padding: 0;
      }
    }
  }
}

/* @keyframes LeftRight {
  0%, 20% { transform: translateX(0%); left: 0; }
  80%, 100% { transform: translateX(-101%); left: 100%; }
} */
@keyframes LeftRight {
  0% { transform: translateX(0%); left: 0; }
  100% { transform: translateX(-101%); left: 100%; }
}
</style>
